import React, {Component} from 'react';
import firebase, {facebookProvider} from 'utils/firebase';
import {FacebookAuthIcon} from 'icons';

import './facebook.scss';

class FacebookButton extends Component {
  login() {
    this.props.onClick();
    firebase
      .auth()
      .signInWithPopup(facebookProvider)
      .catch(err => {
        this.props.onError(err);
      });
  }

  render() {
    return (
      <button className="facebook-button" type="submit" onClick={() => this.login()}>
        <FacebookAuthIcon />
        Continue with Facebook
      </button>
    );
  }
}

export default FacebookButton;
